import React, {useContext, useEffect, useState} from 'react';
import RightDrawer from "../../../../../components/WMS/Mobile/RightDrawer";
import {FormattedMessage} from "react-intl";
import Badge from "../../../../../components/Badge";
import WmsMobileLayout from "../../../wmsMobileLayout";
import CustomButton from "../../../../../components/CustomButton";
import {BarCodeScannerContext} from "../../../../../contexts/barCodeScannerContext";
import {ContextualMenu} from 'components/WMS/Mobile/ContextualMenu';
import {ReactComponent as DotsIcon} from 'assets/img/wms/more.svg';
import {ReactComponent as LogoutIcon} from 'assets/img/logout.svg';
import {ReactComponent as ExtractProduct} from "assets/img/wms/extractProduct.svg";
import {ReactComponent as LocationIcon} from "assets/img/wms/location.svg";
import {ReactComponent as ScanShelf} from "assets/img/wms/scanShelf.svg";
import {ReactComponent as EndMissionIcon} from "assets/img/wms/end_mission.svg";
import ValidatedIcon from "assets/img/validated.svg"
import RedWarning from "assets/img/redWarning.svg"
import {red500} from "assets/jss/main";
import {Grid} from "@mui/material";
import Popup from "../../../../../components/WMS/Mobile/Popup";
import {
    patchWMSContainerMemberWithCodebar, patchWmsContainersWithCodebar, sortingMassTransfer
} from "../../../../../api/wms/wmsContainers/wmsContainers";
import {wmsItemSort} from "../../../../../api/wms/wmsItems/wmsItems";
import {WmsContainerType} from "../../../../../utils/WMSContainerType";
import Toast from "../../../../../components/WMS/Toast";
import PropTypes from "prop-types";
import DisplayItemList from "./components/DisplayItemList";
import SortSingleTrolleyHeader from "./components/SortSingleTrolleyHeader";
import TextEmphasisBloc from "../../../../../components/WMS/TextEmphasisBloc";
import {launchOmniScan} from "../../../../../api/wms/omiScan";
import {WMSContext} from "../../../context/WMSContext";
import {getWMSOmniScanReturnTypeTranslations, WMSOmniScanReturnType} from "../../../../../utils/WMSOmniScanReturnType";
import {getShipmentById} from "../../../../../api/shipment/getWithId";
import _ from 'lodash';
import FullTransfer from "../../../../../components/WMS/FullTransfer";
import ScanFinishContent from "./components/ScanFinishContent";


ToBeSortedSingleTrolley.propTypes = {
    trolley: PropTypes.object.isRequired,
    open: PropTypes.bool.isRequired,
    setOpen: PropTypes.func.isRequired,
    currentMember: PropTypes.object.isRequired,
    trolleyIndex: PropTypes.number,
    isScanned: PropTypes.bool.isRequired,
    refreshTrolley: PropTypes.func.isRequired,
    massTransfer: PropTypes.bool.isRequired
};

function ToBeSortedSingleTrolley({trolley, open, setOpen, currentMember, refreshTrolley, trolleyIndex = 0, isScanned, massTransfer = false}) {
    const {scannedString, resetScannedString, setEnableScan} = useContext(BarCodeScannerContext)
    const {currentInventory} = useContext(WMSContext)
    const [inSorting, setInSorting] = useState(false)
    const [openInSortingCloseModal, setOpenInSortingCloseModal] = useState(false)
    const [scannedWmsItem, setScannedWmsItem] = useState({})
    const [currentTrolley, setCurrentTrolley] = useState()
    const [orderType, setOrderType] = useState("")
    const [alreadyInUseWmsContainer, setAlreadyInUseWmsContainer] = useState({})
    const [openScanModal, setOpenScanModal] = useState(false)
    const [openFullTransferModal, setOpenFullTransferModal] = useState(false)
    const [openFullHiveModal, setOpenFullHiveModal] = useState(false)
    const [isScanFinish, setIsScanFinish] = useState(false)
    const [isMultiFirstItem, setIsMultiFirstItem] = useState(true)

    const [openToast, setOpenToast] = useState(false)
    const [toastIcon, setToastIcon] = useState()
    const [toastIconAlt, setToastIconAlt] = useState("")
    const [toastTitle, setToastTitle] = useState()
    const [toastSubtitle, setToastSubtitle] = useState()

    const handleSortItem = (container) => {
        wmsItemSort(scannedWmsItem.id, container.codebar).then((response) => {
            refreshTrolley(trolley)

            handleOpenToast(container)

            if (openFullHiveModal) {
                patchWmsContainersWithCodebar(alreadyInUseWmsContainer.codebar, {maxCapacity: true}).then(r => {
                    handleCloseFullHiveModal()
                })
            } else {
                handleCloseScanModal()
            }
            setOrderType("")
            setAlreadyInUseWmsContainer({})
        })
    }

    const handleGroupDisplayedItem = (toBeGroupedTrolley) => {
        let tempTrolley = toBeGroupedTrolley
        tempTrolley.itemCount = 0
        let items = [...tempTrolley.wmsItems]
        let groupedItems = []
        items.map((item) => {
            let foundItem = groupedItems.find(groupedItem => item.lineItem.variationSku === groupedItem.lineItem.variationSku)
            if (foundItem) {
                foundItem.count++
                tempTrolley.itemCount++
                if (foundItem.lineItem.currentShipment.multi !== item.lineItem.currentShipment.multi) {
                    foundItem.shipmentType = <FormattedMessage id={"wms.sorting.monoAndMulti"}/>
                }
            } else {
                tempTrolley.itemCount++
                item.count = 1
                item.shipmentType = item.lineItem.currentShipment.multi ? <FormattedMessage id={"wms.sorting.multi"}/> :
                    <FormattedMessage id={"wms.sorting.mono"}/>
                groupedItems.push(item)
            }
        })

        tempTrolley.wmsItems = groupedItems

        return tempTrolley
    }

    function createIconToast(icon, alt) {
        return (
            <img
                src={icon}
                alt={alt}
                style={{
                    width: '20px',
                    height: '20px',
                }}
            />
        )
    }

    const handleOpenToast = (container) => {
        if ("multi" === orderType) {
            setToastIcon(createIconToast(ValidatedIcon, "validated-icon"));
            setToastTitle(<FormattedMessage id={"wms.sorting.multi.success.toast.title"}/>)
            setToastSubtitle(
                <Grid container flexDirection={"column"}>
                    <Grid item><FormattedMessage
                        id={"wms.sorting.multi.success.toast.subtitle.hiveName"}/>: {container.hiveName}</Grid>
                    <Grid item><FormattedMessage
                        id={"wms.sorting.multi.success.toast.subtitle.slotName"}/>: {container.name}</Grid>
                </Grid>
            )
        }

        if ("mono" === orderType) {
            setToastIcon(createIconToast(ValidatedIcon, "validated-icon"));
            setToastTitle(<FormattedMessage id={"wms.sorting.mono.success.toast.title"}/>)
            setToastSubtitle(container.name)
        }

        setOpenToast(true)
    }

    // This might be removed in V2 when we implement multi-hiveContainer sorting.
    const handleOpenWrongContainerToast = (container = null) => {
        setToastIcon(createIconToast(RedWarning, 'red-warning'));
        setToastTitle(<FormattedMessage id={"wms.sorting.toast.wrongContainer.title"}/>)
        if (container) {
            setToastSubtitle(<><FormattedMessage
                id={"wms.sorting.toast.wrongContainer.subtitle"}/>: {container.hiveName} • {container.name}</>)
        }
        setOpenToast(true)
        setEnableScan(true)
    }

    const handleFullContainerScan = (container = null) => {
        setToastIcon(createIconToast(RedWarning, "error"))
        setToastTitle(<FormattedMessage id={"wms.sorting.toast.fullHiveScan.title"}/>)

        if (container) {
            setToastSubtitle(<FormattedMessage id={"wms.sorting.toast.fullHiveScan.subtitle"} values={{hiveName: container.hiveName+" • "+container.name}}/>)
        }

        setOpenToast(true)
        setEnableScan(true)
    }

    const handleAlreadyUsedHive = () => {
        setToastIcon(createIconToast(RedWarning, "error"))
        setToastTitle(<FormattedMessage id={"wms.sorting.toast.alreadyUsedHiveScan.title"} />)
        setToastSubtitle(<FormattedMessage id={"wms.sorting.toast.alreadyUsedHiveScan.subtitle"} />)

        setOpenToast(true)
        setEnableScan(true)
    }

    const handleOmniScanNotFound = () => {
        setToastIcon(createIconToast(RedWarning, 'red-warning'))
        setToastTitle(<FormattedMessage id={"wms.omniScan.notFound"}/>)
        setOpenToast(true)
        setEnableScan(true)
    }

    const goBackToSorting = () => {
        setOpenInSortingCloseModal(false)
        setInSorting(false)
        setOpen(false);
        setScannedWmsItem({})
    }

    async function removeMemberFromTrolley(trolleyBarcode) {
        return await patchWMSContainerMemberWithCodebar(trolleyBarcode, null);
    }

    const handleClose = () => {
        if (inSorting && !isScanFinish) {
            setOpenInSortingCloseModal(true)
        } else {
            setOpen(false);
        }
    }

    const handleCloseToast = () => {
        setToastIcon(null)
        setToastIconAlt(null)
        setToastTitle(null)
        setToastIconAlt(null)
        setOpenToast(false)
    }

    const handleCloseInSortingModal = () => {
        setOpenInSortingCloseModal(false)
    }

    const handleStartSorting = () => {
        patchWMSContainerMemberWithCodebar(currentTrolley.codebar, currentMember).then((response) => {
            setInSorting(true)
            setEnableScan(true)
        })
    }

    const handleCloseScanModal = () => {
        setOpenScanModal(false)
        setOrderType("")
        setScannedWmsItem({})
    }

    const handleCloseFullHiveModal = () => {
        setOpenFullHiveModal(false)
        setOrderType("")
        setScannedWmsItem({})
    }

    const haveAlreadyUsedContainer = (item) => {
        return getShipmentById(item.lineItem.currentShipment.id).then((response) => {
            let lineItems = response.lineItems
            let shipmentContainers = lineItems.filter((lineItem) => WmsContainerType.HIVE === lineItem.wmsItem?.wmsContainer?.type)

            if (0 === shipmentContainers.length) {
                return [];
            }

            if (1 < shipmentContainers.length) {
                shipmentContainers = shipmentContainers.filter((lineItem) => false === lineItem.wmsItem.wmsContainer?.maxCapacity)
            }


            return shipmentContainers[0].wmsItem.wmsContainer
        }).catch(() => {
            return false
        })
    }

    const handleScanningArticle = async () => {
        let matchedItem = null
        for (let item of currentTrolley.wmsItems) {
            const barcode = item.barcode ?? item.lineItem.variation.barcode
            if (!barcode || scannedString !== barcode) {
                continue
            }
            matchedItem = item
        }

        if (null === matchedItem) {
            setEnableScan(true)
            return;
        }

        setScannedWmsItem(matchedItem)
        const isMultiShipment = matchedItem.lineItem.currentShipment.multi
        if (isMultiShipment) {
            const wmsContainer = await haveAlreadyUsedContainer(matchedItem)
            if (false === wmsContainer) {
                setEnableScan(true)
                return
            }

            setOrderType('multi');

            // if wmscontainer object
            if (!Array.isArray(wmsContainer) && wmsContainer.id) {
                setAlreadyInUseWmsContainer(wmsContainer)
                setIsMultiFirstItem(false)
            }
        } else {
            setOrderType("mono")
        }
    }

    const handleWrongEntityType = (response) => {
        const scannedType = <FormattedMessage id={getWMSOmniScanReturnTypeTranslations(response[0].entityType)}/>
        setToastTitle(<FormattedMessage id={'wms.sorting.toast.wrongBarcodeScanned.title'}/>)
        setToastSubtitle(
            <FormattedMessage
                id={'wms.sorting.toast.wrongBarcodeScanned.subtitle'}
                values={{scannedType: scannedType}}/>
        )
        setToastIcon(createIconToast(RedWarning, 'red-warning'));
        setToastIconAlt(createIconToast('red-warning'));
        setOpenToast(true)
        setEnableScan(true)

    }

    const handleScanningContainer = () => {
        // If its a multi and an article is already in a sorting container
        if (0 < Object.keys(alreadyInUseWmsContainer).length) {

            if (openFullHiveModal && scannedString === alreadyInUseWmsContainer.codebar) {
                handleFullContainerScan(alreadyInUseWmsContainer)
                return
            }

            launchOmniScan(scannedString, currentInventory.id, {container: ["hive"]}).then((response) => {
                if (response.length === 1 && WMSOmniScanReturnType.CONTAINER === response[0].entityType) {
                    if (scannedString === alreadyInUseWmsContainer.codebar || openFullHiveModal) {
                        handleSortItem(response[0])
                    } else if (!openFullHiveModal) {
                        handleOpenWrongContainerToast(alreadyInUseWmsContainer)
                    }
                } else {
                    if (response.length === 1) {
                        handleWrongEntityType(response)
                    }
                    if (response.length === 0) {
                        handleOmniScanNotFound()
                    }
                }
                resetScannedString()
            })

        } else {
            // If there is no container already associated with the order it is either a multi item order, and we scanned the first item, or a mono item order.
            launchOmniScan(scannedString, currentInventory.id, {container: ["hive", "shelf"]}).then((response) => {
                if (response.length === 1 && WMSOmniScanReturnType.CONTAINER === response[0].entityType) {
                    if (WmsContainerType.HIVE === response[0].type || WmsContainerType.SHELF === response[0].type) {
                        if ('multi' === orderType) {
                            if (WmsContainerType.HIVE === response[0].type) {
                                if (response[0].maxCapacity) {
                                    handleFullContainerScan(response[0])
                                    return
                                }

                                if (response[0].hasItems) {
                                    handleAlreadyUsedHive()
                                    return
                                }

                                handleSortItem(response[0])
                            } else {
                                handleOpenWrongContainerToast()
                            }
                        } else {
                            handleSortItem(response[0])
                        }
                    } else {
                        handleOpenWrongContainerToast()
                    }
                } else {
                    if (response.length === 1) {
                        handleWrongEntityType(response)
                    }
                    if (response.length === 0) {
                        handleOmniScanNotFound()
                    }
                }
                resetScannedString()
            })
        }
    }

    const handleGroupedItems = (trolley) => {
        if (trolley && trolley.wmsItems.length > 0) {
            let groupedTrolley = _.cloneDeep(trolley)
            groupedTrolley = handleGroupDisplayedItem(groupedTrolley)

            setCurrentTrolley(groupedTrolley)
        } else {
            setCurrentTrolley({
                ...currentTrolley,
                wmsItems: []
            })
        }
    }

    const handleFullHive = () => {
        setOpenScanModal(false)
        setOpenFullHiveModal(true)
    }

    function getScanPopupTitle() {
        if (openFullHiveModal) {
            return <FormattedMessage id={"wms.sorting.scan.fullHiveModal.title"}/>
        }

        if (orderType === "mono") {
            return <FormattedMessage id={"wms.sorting.scan.monoOrder.title"}/>
        }

        if (orderType === "multi") {
            return <FormattedMessage id={"wms.sorting.scan.multiOrder.title"}/>
        }

    }

    function getScanPopupSubtitle() {
        if (openFullHiveModal) {
            return <FormattedMessage id={"wms.sorting.scan.fullHiveModal.subtitle"} values={{hiveName: ""+alreadyInUseWmsContainer.hiveName+" • "+alreadyInUseWmsContainer.name}}/>
        }

        if (orderType === "mono") {
            return <FormattedMessage id={"wms.sorting.scan.monoOrder.subtitle"}/>;
        }

        if (orderType === "multi") {
            if (isMultiFirstItem) {
                return <FormattedMessage id={"wms.sorting.scan.multiOrder.firstItem.subtitle"}/>;
            }

            return <FormattedMessage id={"wms.sorting.scan.multiOrder.subtitle"}/>;
        }
    }

    function getScanPopupIcon() {
        if (orderType === "mono") {
            return <LocationIcon/>;
        }

        if (orderType === "multi") {
            return <ScanShelf/>;
        }
    }

    const handleCloseFullTransferModal = (doRefresh) => {
        if (doRefresh) {
            refreshTrolley(trolley)
            setInSorting(false)

        }

        setOpenFullTransferModal(false)
    }

    useEffect(() => {
        if (!trolley || !currentMember) {
            return;
        }

        if (trolley.member && trolley.member.id && trolley.member.id === currentMember.id) {
            setInSorting(true);
        }
    }, [trolley, currentMember])

// TO OPEN THE SCAN MODAL
    useEffect(() => {
        if ("" !== orderType) {
            setOpenScanModal(true)
            setEnableScan(true)
        }
    }, [orderType]);

    useEffect(() => {
        if (currentTrolley && false === openScanModal && 0 === currentTrolley.wmsItems.length) {
            removeMemberFromTrolley(currentTrolley.codebar).then((response) => {
                setIsScanFinish(true)
                setOpenFullTransferModal(false)
            })
        } else {
            setIsScanFinish(false)
        }
    }, [currentTrolley]);

// IF TROLLEY WAS SCANNED
    useEffect(() => {
        if (isScanned && currentTrolley) {
            handleStartSorting()
        }
    }, [isScanned, currentTrolley]);

    useEffect(() => {
        if (trolley) {
            handleGroupedItems(trolley)
        }
        setEnableScan(true)
    }, [trolley]);


// WHEN SCANNING
    useEffect(() => {
        if (!openFullTransferModal && inSorting && scannedWmsItem && 0 < scannedString.length) {
            setEnableScan(false)
            // WHEN SCANNING AN ARTICLE
            if (0 === Object.keys(scannedWmsItem).length) {
                handleScanningArticle()
            }

            // WHEN SCANNING A CONTAINER
            if ((true === openScanModal || true === openFullHiveModal) && 0 < Object.keys(scannedWmsItem).length) {
                handleScanningContainer()
            }

            if (0 < Object.keys(scannedWmsItem).length && false === openScanModal && false === openFullHiveModal) {
                setScannedWmsItem({})
                setEnableScan(true)
            }
        }
    }, [scannedString]);

    return (
        <RightDrawer
            open={open}
            handleClose={handleClose}
            headerLeftContent={(
                <b style={{marginLeft: '16px', fontSize: '16px'}}>
                    {trolley.name ?? trolleyIndex}
                </b>
            )}
            headerRightContent={
                <>
                    <Popup
                        open={openInSortingCloseModal}
                        onClose={handleCloseInSortingModal}
                        title={<FormattedMessage id={"wms.sorting.inSorting.stopSorting.title"}/>}
                        subtitle={<FormattedMessage id={"wms.sorting.inSorting.stopSorting.subtitle"}/>}
                        icon={<ExtractProduct/>}
                    >
                        <Grid container direction={"column"} gap={"16px"}>
                            <Grid item>
                                <CustomButton
                                    onClick={() => {
                                        removeMemberFromTrolley(currentTrolley.codebar).then(() => goBackToSorting())
                                    }}
                                    fullWidth
                                    color={'default'}
                                >
                                    <FormattedMessage id={"wms.sorting.inSorting.stopSorting.validButton"}/>
                                </CustomButton>
                            </Grid>
                            <Grid item>
                                <CustomButton onClick={handleCloseInSortingModal} fullWidth>
                                    <FormattedMessage id={"wms.sorting.inSorting.stopSorting.cancelButton"}/>
                                </CustomButton>
                            </Grid>
                        </Grid>
                    </Popup>

                    {openScanModal && (
                        <Popup
                            open={openScanModal}
                            onClose={handleCloseScanModal}
                            title={getScanPopupTitle()}
                            subtitle={getScanPopupSubtitle()}
                            icon={getScanPopupIcon()}
                        >
                            {orderType === "multi" && 0 < Object.keys(alreadyInUseWmsContainer).length && (
                                <Grid container direction={'column'} justifyContent={'space-between'}>
                                    <TextEmphasisBloc
                                        leftPart={<>{alreadyInUseWmsContainer.hiveName ?? <></>} • {alreadyInUseWmsContainer.name}</>}/>
                                    <CustomButton fullWidth onClick={handleFullHive}> <FormattedMessage
                                        id={"wms.sorting.scan.multiOrder.full"}/> </CustomButton>
                                </Grid>
                            )}
                        </Popup>
                    )}

                    {openFullTransferModal && (
                        <Popup
                            open={openFullTransferModal}
                            onClose={handleCloseFullTransferModal}
                            title={<FormattedMessage id={"wms.sorting.fullTransferModal.title"}/>}
                            subtitle={<FormattedMessage id={"wms.sorting.fullTransferModal.subtitle"}/>}
                            icon={<EndMissionIcon/>}
                            isMobile
                        />
                    )}

                    {openFullHiveModal && (
                        <Popup
                            open={openFullHiveModal}
                            onClose={handleCloseFullHiveModal}
                            title={getScanPopupTitle()}
                            subtitle={getScanPopupSubtitle()}
                            icon={getScanPopupIcon()}
                        />
                    )}

                    {openToast && (
                        <Toast
                            icon={toastIcon}
                            title={toastTitle}
                            subtitle={toastSubtitle}
                            open={openToast}
                            handleClose={handleCloseToast}
                        />
                    )}

                    {isScanFinish &&
                        <Badge
                            label={<FormattedMessage id={"wms.sorting.scan.scanIsFinished.label"}/>}
                            color={"online"}
                            rounded
                            isBold={false}
                            size={"large"}
                        /> ||
                        <Badge
                            rounded
                            isBold={false}
                            size={"large"}
                        >
                            {currentTrolley && inSorting && (
                                <>
                                    {currentTrolley.itemCount} <FormattedMessage id={"wms.sorting.toScanArticle"}/>
                                </>
                            )}
                            {currentTrolley && !inSorting && (
                                <>
                                    {currentTrolley.itemCount} <FormattedMessage id={"wms.sorting.article"}/>
                                </>
                            )}
                        </Badge>
                    }
                    {inSorting && (
                        <ContextualMenu icon={DotsIcon}>
                            <Grid container flexDirection={'row'} justifyContent={"space-between"} alignItems={"center"}
                                  onClick={handleClose}>
                                <Grid item style={{color: red500}}>
                                    <FormattedMessage id={"wms.sorting.inSorting.finishSorting.label"}/>
                                </Grid>
                                <Grid item style={{maxWidth: '20px', maxHeight: '20px'}}>
                                    <LogoutIcon/>
                                </Grid>
                            </Grid>
                        </ContextualMenu>
                    )}
                </>}
        >
            <WmsMobileLayout disableMargin>
                <WmsMobileLayout.Content>
                    {isScanFinish === false ? (
                        <>
                            <SortSingleTrolleyHeader
                                isInSorting={inSorting}
                                trolleyName={trolley.name}
                                trolleyIndex={trolleyIndex}
                            />
                            {currentTrolley && (
                                <DisplayItemList
                                    currentTrolley={currentTrolley}
                                    refreshTrolley={() => refreshTrolley(trolley)}
                                />
                            )}
                        </>
                    ) : (
                        <ScanFinishContent goBackToSorting={goBackToSorting} />
                    )}
                </WmsMobileLayout.Content>
                    <WmsMobileLayout.Footer>
                        {isScanFinish === false && !inSorting && (
                            <CustomButton onClick={() => handleStartSorting()} fullWidth>
                                <FormattedMessage id={"wms.sorting.trolleyPeek.button"}/> {trolleyIndex}
                            </CustomButton>
                        )}
                        {isScanFinish === false && massTransfer && (
                            <FullTransfer
                                handleIsValid={(doRefresh) => handleCloseFullTransferModal(doRefresh)}
                                currentContainer={trolley}
                                inSorting={inSorting}
                                toContainers={[
                                    WmsContainerType.HIVE,
                                    WmsContainerType.SHELF
                                ]}
                            />
                        )}
                    </WmsMobileLayout.Footer>

            </WmsMobileLayout>
        </RightDrawer>
    );
}

export default ToBeSortedSingleTrolley;
